import { render } from "./InputImage.vue?vue&type=template&id=b2fafb5a"
import script from "./InputImage.vue?vue&type=script&lang=js"
export * from "./InputImage.vue?vue&type=script&lang=js"

import "./InputImage.vue?vue&type=style&index=0&id=b2fafb5a&lang=scss"
script.render = render

export default script